import cloneDeep from 'lodash/cloneDeep';
import merge from 'lodash/merge';
import * as types from './types';
import { filters, filtersTransformer } from '../shared/filters';
import { applicationsDropdownFilters } from '../shared/filters';
import * as geographyTypes from '../geographies/types';
import * as locationTypes from 'redux/employer/types';
import { clone, isArray } from 'lodash';

const filtersIndex = {
  query: -1,
  location_id: 0,
  education_level: 1,
  by_major_in: 2,
  work_experience: 3,
  desired_location: 4,
  certifications: 5,
  education_philosophy: 6,
  languages: 7,
  job_search_status: 8,
  employment_type: 9,
  role_type: 10,
};

const excludedFilters = ['distance'];

const sortedFilters = [
  ...filters
    .filter((filter) => !excludedFilters.includes(filter.id))
    .sort((filter1, filter2) => {
      return filtersIndex[filter1.id] > filtersIndex[filter2.id] ? 1 : -1;
    }),
  applicationsDropdownFilters,
];

const initialState = {
  loading: null,
  loadingOne: null,
  currentApplication: {},
  jobApplications: [],
  currentPage: 1,
  nextPage: null,
  totalPages: null,
  filters: sortedFilters,
  unreviewedApplicants: {
    loading: false,
    loaded: false,
    count: 0,
  },
};

const candidateReducer = (state = cloneDeep(initialState), { type, payload, errors }) => {
  switch (type) {
    case types.PAGINATION_LOAD_SUCCESS:
      if (payload.startedAt !== state.startedAt) {
        return state;
      }

      return {
        ...state,
        nextPage: payload.pagination.next_page,
        totalPages: payload.pagination.total_pages,
        currentPage: payload.pagination.current_page,
      };
    case types.APPLICATIONS_LOAD_START:
      return {
        ...state,
        startedAt: payload.startedAt,
        loading: true,
      };
    case types.APPLICATION_LOAD_START:
      return {
        ...state,
        loadingOne: true,
      };
    case types.APPLICATIONS_LOAD_SUCCESS:
      if (payload.startedAt !== state.startedAt) {
        return state;
      }

      return {
        ...state,
        jobApplications: payload.data,
        meta: payload.meta || {},
        loading: false,
      };

    case types.APPLICATION_LOAD_SUCCESS: {
      let jobApplications = cloneDeep(state.jobApplications);
      const index = jobApplications.findIndex((application) => application.id === payload.id);

      if (index !== -1) {
        jobApplications[index] = merge(jobApplications[index], payload);
      } else {
        jobApplications = [...state.jobApplications, payload];
      }

      return {
        ...state,
        currentApplication: payload,
        loadingOne: false,
        jobApplications,
      };
    }

    case types.APPLICATIONS_LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        loadingOne: false,
      };

    case types.APPLICATIONS_UNREVIEWED_APPLICANTS_LOAD_START:
      return {
        ...state,
        unreviewedApplicants: {
          ...state.unreviewedApplicants,
          loading: true,
        },
      };

    case types.APPLICATIONS_SET_UNREVIEWED_APPLICANTS_COUNT:
      return {
        ...state,
        unreviewedApplicants: {
          count: payload,
          loading: false,
          loaded: true,
        },
      };

    case types.APPLICATIONS_SET_UNREVIEWED_APPLICANTS_LOAD_FAILURE:
      return {
        ...state,
        unreadMessages: {
          count: undefined,
          loading: false,
          loaded: true,
        },
      };
    case locationTypes.LOCATIONS_LOAD_SUCCESS: {
      const options = payload.map((location) => {
        return {
          value: location.id,
          label: location.name,
          checked: false,
          subLabel: location.address,
        };
      });

      const locations_options = {
        id: 'location_id',
        name: 'Location applied to',
        type: 'checkbox',
        options,
      };

      const newFilters = [
        locations_options,
        ...(state.filters || []).filter((filter) => filter.id !== 'location_id'),
      ];
      return { ...state, filters: [...newFilters] };
    }
    case geographyTypes.GEOGRAPHY_OPTIONS_LOAD_SUCCESS: {
      const newFilters = filtersTransformer(payload, state.filters);
      return { ...state, filters: [...newFilters] };
    }
    // TODO: fix this to use some constant, previously didnt work
    case 'certificationCategories/fetch/fulfilled': {
      const options = payload.flatMap((certCategory) => {
        return certCategory
          .certificationOptions()
          .toArray()
          .flatMap((opt) => ({
            value: opt.id,
            label: opt.title,
            checked: false,
            group: certCategory.title,
          }));
      });
      state.filters.find((filter) => filter.id === 'certifications').options = options;

      return { ...state, filters: [...state.filters] };
    }
    case geographyTypes.CURRENT_GEOGRAPHY_LOAD_SUCCESS: {
      const profileQuestions = payload.profileQuestions().toArray();
      const philosophyOptions = profileQuestions
        .find((pq) => pq.name === 'education_approach')
        .options.map((opt) => ({ value: opt.value, label: opt.value, checked: false }));

      const locationOptions = profileQuestions
        .find((pq) => pq.name === 'desired_location')
        .options.map((opt) => ({ value: opt.value, label: opt.value, checked: false }));

      const roleOptions = profileQuestions
        .find((pq) => pq.name === 'desired_job')
        .options.map((opt) => ({ value: opt.value, label: opt.value, checked: false }));

      state.filters.find((filter) => filter.id === 'education_philosophy').options =
        philosophyOptions;

      if (payload.displayNeighborhoodLocations) {
        state.filters.find((filter) => filter.id === 'desired_location').options = locationOptions;
      }

      state.filters.find(
        (filter) => filter.id === 'role_type' && filter.label !== 'Other',
      ).options = roleOptions;

      return { ...state, filters: [...state.filters] };
    }
    case types.APPLICATIONS_SEARCH_CHANGE_FILTER: {
      const filters = state.filters;
      const section = filters.find((filter) => filter.id === payload.section.id);
      let { option } = payload;
      if (section.type === 'checkbox' && section.id !== 'languages') {
        option = section.options.find(
          (option) =>
            option.value === payload.option.value && option.geography === payload.option.geography,
        );
        option.checked = !option.checked;
      } else if (section.type === 'checkbox' && section.id === 'languages') {
        if (isArray(option)) {
          // in this case, we send all of the currently selected options from the language typeahead component
          // (because that's how the typeahead works)
          const selectedIds = option.map((opt) => opt.value);
          section.options.forEach((opt) => {
            opt.checked = selectedIds.includes(opt.value);
          });
        } else {
          // in this case, we are sending the option from the filter drawer 'removeFilter' function
          option.checked = false;
        }
      } else if (section.type === 'dropdown') {
        const updatedOptions = section.options.map((opt) => ({
          ...opt,
          selected: option.id === opt.id && !option.selected,
        }));
        section.options = updatedOptions;
      } else {
        section.value = option;
      }

      return {
        ...state,
        filters: clone(filters),
      };
    }

    case types.APPLICATIONS_SEARCH_RESET_FILTER: {
      const resFilters = cloneDeep(state.filters);
      resFilters.forEach((filter) => {
        switch (filter.type) {
          case 'checkbox':
            filter.options.forEach((option) => {
              option.checked = false;
            });
            break;
          case 'dropdown':
            filter.options.forEach((option) => {
              option.selected = option.defaultValue;
            });
            break;
          case 'complex':
            filter.value = initialState.filters.find((f) => f.id === filter.id)?.value || '';
            break;
          case 'text':
          default:
            filter.value = '';
        }
      });

      return {
        ...state,
        filters: resFilters,
      };
    }

    default:
      return state;
  }
};

export default candidateReducer;
